import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

// Last-resort fallbacks if the API is unreachable on first paint.
// Kept identical to the seeded defaults in backend/server.py so the buttons
// still work even if the hydration request fails for some reason.
const DEFAULTS = {
  whatsapp: "5534998282258",
  email: "comercialpatos@solluteocupacional.com.br",
  phone_display: "(34) 99828-2258",
};

const SalesContext = createContext({
  ...DEFAULTS,
  refresh: () => {},
});

export function SalesProvider({ children }) {
  const [cfg, setCfg] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings/sales");
      const data = r.data || {};
      // Guard against API returning empty strings — prefer defaults in that case.
      setCfg({
        whatsapp: data.whatsapp || DEFAULTS.whatsapp,
        email: data.email || DEFAULTS.email,
        phone_display: data.phone_display || DEFAULTS.phone_display,
      });
    } catch {
      // network/cors issue — keep current value, never block UI on this.
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SalesContext.Provider value={{ ...cfg, refresh }}>
      {children}
    </SalesContext.Provider>
  );
}

/**
 * Reactive sales-contact data + URL helpers. Components that use these will
 * re-render automatically when an admin edits the contact in /admin/configuracoes.
 */
export function useSales() {
  const ctx = useContext(SalesContext);
  return {
    whatsapp: ctx.whatsapp,
    email: ctx.email,
    phoneDisplay: ctx.phone_display,
    refresh: ctx.refresh,
    whatsappUrl: (message = "Olá! Tenho interesse no plano completo do Sollute NR-01.") =>
      `https://wa.me/${ctx.whatsapp}?text=${encodeURIComponent(message)}`,
    mailtoUrl: (
      subject = "Plano completo · Sollute NR-01",
      body = "Olá, gostaria de saber mais sobre o plano completo.",
    ) => `mailto:${ctx.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
  };
}
